import { atom } from "recoil";

export const selectedParcelsData = atom({
  key: "selectedParcelsData",
  default: [],
});

export const selectedUnitsGroup = atom({
  key: "selectedUnitsGroup",
  default: [],
});

export const selectedUnits = atom({
  key: "selectedUnits",
  default: [],
});

export const batchUnits = atom({
  key: "batchUnits",
  default: [],
});

export const selectedMyOrders = atom({
  key: "selectedMyOrders",
  default: [],
});

export const offersData = atom({
  key: "offersData",
  default: [],
});

export const selectedOfferData = atom({
  key: "selectedOfferData",
  default: [],
});
export const selectedOfferParcels = atom({
  key: "selectedOfferParcels",
  default: [],
});

export const createOfferParcels = atom({
  key: "createOfferParcels",
  default: [],
});

export const editOfferData = atom({
  key: "editOfferData",
  default: {},
});

export const createOfferParcelsFilter = atom({
  key: "createOfferParcelsFilter",
  default: ["==", ["id"], 0],
});

export const currentRegion = atom({
  key: "currentRegion",
  default: {
    orderIndex: 1,
    id: 10,
    key: "Riyadh",
    name: "الرياض",
    mapStyleUrl: import.meta.env.VITE_APP_MAP_STYLE,
    mapZoomLevel: 10,
    metricsUrl: "/Riyadh/mobile-metrics",
    defaultTransactionsDateRange: "-1/y",
    centroid: {
      x: 46.6893526894509,
      y: 24.6787559510409,
    },
    restrictBoundaryBox: {
      southwest: {
        x: 46.265364184769595,
        y: 23.986904579297715,
      },
      northeast: {
        x: 47.342260256150155,
        y: 25.781380632818795,
      },
    },
    provinces: [
      {
        id: 101000,
        name: "الرياض",
        centroid: {
          x: 47.03883031601278,
          y: 24.741835201622706,
        },
      },
      {
        id: 101001,
        name: "الدرعية",
        centroid: {
          x: 46.29108711441922,
          y: 24.862047320413982,
        },
      },
    ],
  },
});

export const currentTransactionTrackerRegion = atom({
  key: "currentTransactionTrackerRegion",
  default: {},
});
